import { render, staticRenderFns } from "./SimulatorWidget.vue?vue&type=template&id=413da7da&scoped=true&"
import script from "./SimulatorWidget.vue?vue&type=script&lang=js&"
export * from "./SimulatorWidget.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorWidget.vue?vue&type=style&index=0&id=413da7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413da7da",
  null
  
)

export default component.exports